var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0702 5.73C19.4602 5.57 17.8502 5.45 16.2302 5.36V5.35L16.0102 4.05C15.8602 3.13 15.6402 1.75 13.3002 1.75H10.6802C8.35016 1.75 8.13016 3.07 7.97016 4.04L7.76016 5.32C6.83016 5.38 5.90016 5.44 4.97016 5.53L2.93016 5.73C2.51016 5.77 2.21016 6.14 2.25016 6.55C2.29016 6.96 2.65016 7.26 3.07016 7.22L5.11016 7.02C10.3502 6.5 15.6302 6.7 20.9302 7.23C20.9602 7.23 20.9802 7.23 21.0102 7.23C21.3902 7.23 21.7202 6.94 21.7602 6.55C21.7902 6.14 21.4902 5.77 21.0702 5.73Z",
    fill: "#FF4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2302 8.64C18.9902 8.39 18.6602 8.25 18.3202 8.25H5.68024C5.34024 8.25 5.00024 8.39 4.77024 8.64C4.54024 8.89 4.41024 9.23 4.43024 9.58L5.05024 19.84C5.16024 21.36 5.30024 23.26 8.79024 23.26H15.2102C18.7002 23.26 18.8402 21.37 18.9502 19.84L19.5702 9.59C19.5902 9.23 19.4602 8.89 19.2302 8.64ZM13.6602 18.25H10.3302C9.92024 18.25 9.58024 17.91 9.58024 17.5C9.58024 17.09 9.92024 16.75 10.3302 16.75H13.6602C14.0702 16.75 14.4102 17.09 14.4102 17.5C14.4102 17.91 14.0702 18.25 13.6602 18.25ZM14.5002 14.25H9.50024C9.09024 14.25 8.75024 13.91 8.75024 13.5C8.75024 13.09 9.09024 12.75 9.50024 12.75H14.5002C14.9102 12.75 15.2502 13.09 15.2502 13.5C15.2502 13.91 14.9102 14.25 14.5002 14.25Z",
    fill: "#FF4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/deleteRed.95d3d43bdea4bb71f7479c3db353f3f2.svg";
export { ForwardRef as ReactComponent };